<template>
  <button class="button info-button top right" @click="clicked">?</button>
</template>

<script>

export default {
  name: 'InfoButton',
  methods: {
    clicked() {
      // console.log('should toggle info')
      this.$eventHub.$emit('toggleInfo')
    },
  },
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/InfoButton.vue